'use client'

import * as React from 'react'
import { Button } from '@/components/ui/deprecated-button'
import { InviteLink } from '@/components/invite-link'
import { FormControl } from '@/components/form-control'
import { useInviteLink } from '@/modules/invite/use-invite-link'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'

export function GiveToGetStudentModal({
  isOpen,
  onClose,
  isAuthenticated,
}: {
  isOpen: boolean | null
  onClose: () => void
  isAuthenticated: boolean
}): React.JSX.Element {
  const { inviteUrl, loading: inviteLinkLoading } = useInviteLink({
    isAuthenticated,
  })

  return (
    <Dialog open={Boolean(isOpen)} onOpenChange={onClose}>
      <DialogContent
        title="Ready to see all salaries?"
        className="overflow-auto"
      >
        <DialogTitle className="text-2xl">
          Thanks for joining Marit!
        </DialogTitle>

        <p className="text-copy-primary">
          Marit only works because everyone has to share their salary in order
          to get access, but because you don&apos;t yet have a salary to share,
          we have a different ask.
        </p>
        <p className="mt-3 text-copy-primary">
          Help us grow our community by inviting friends to join Marit and
          you&apos;ll unlock 1 full year of access to all salary details. The
          easiest way to share is by group text, WhatsApp, email, or social
          media.
        </p>
        <FormControl label="Invite via Personalized Link" className="mt-6">
          <InviteLink inviteUrl={inviteUrl} loading={inviteLinkLoading} />
        </FormControl>
        <Button
          className="w-full mt-6"
          size="lg"
          onClick={onClose}
          disabled={inviteLinkLoading}
        >
          See All Salaries
        </Button>
      </DialogContent>
    </Dialog>
  )
}
